//#region redux
import { invoiceSnoozed } from "store/actions/invoiceActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import { useSnoozeAction } from "components/common";
import { LocalizationHelperInstance } from "utils/helpers";

function useInvoiceSnoozeAction(id: number, markAsDone: (id: number) => void) {
  const dispatch = useDispatch();

  const onSnoozeInvoiceSuccess = () => {
    dispatch(invoiceSnoozed(id));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.Invoice,
    onSnoozeInvoiceSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Invoice)
  );

  return snoozeAction;
}

export default useInvoiceSnoozeAction;
